export const GET_ROLES = '[Role Action] Get Roles';
export const CONFIRMED_GET_ROLES = '[Role Action] Confirmed Get Roles';
